<div class="card h-full w-full">
  <p-tabMenu [model]="items" [activeItem]="activeItem"></p-tabMenu>
  <div class="h-full w-full py-1">
    <ng-container *ngIf="selectedTab">
      <ng-container *ngComponentOutlet="selectedTab.component"></ng-container>
    </ng-container>
  </div>
</div>
